import {usePaginatedViewVariablesContext} from '../state-providers/memex-items/context/paginated-view-variables'
import type {PaginatedMemexItemsQueryVariables} from '../state-providers/memex-items/queries/types'

export const useIsFetchingVariable = (trackedVariable: keyof PaginatedMemexItemsQueryVariables) => {
  const context = usePaginatedViewVariablesContext()
  return context?.staleVariable === trackedVariable
}
